import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  createRescheduleBundles,
  CreateRescheduleBundlesRequest,
} from "../services/create-reschedule-bundles";

export function useCreateRescheduleBundles() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreateRescheduleBundlesRequest) =>
      createRescheduleBundles(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["bundles"] });
    },
  });
}
